import { defineMessages, FormattedMessage } from "react-intl";

export type FormattedMessageProps = React.ComponentProps<
    typeof FormattedMessage
>;

export const messages = defineMessages({
    timeout: {
        id: "siteActivation.nameSite.error.timeout",
        defaultMessage:
            "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "siteActivation.nameSite.error.invalidName",
        defaultMessage:
            "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "siteActivation.nameSite.error.maxLength",
        defaultMessage:
            "That's a bit too long — try something 50 characters or less."
    },
    unavailable: {
        id: "siteActivation.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    networkError: {
        id: "siteActivation.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});
